class GreedyOnePageShop extends HTMLElement {
  connectedCallback() {
    this.products = [...this.querySelectorAll('[data-gu-product]')].map((el) => {
      const jsonEl = el.querySelector('[data-gu-product-json]');
      let data = {};
      try { data = JSON.parse(jsonEl?.textContent || '{}'); } catch (e) { console.error('Bad product JSON', e); }
      return { card: el, cardImageIndex: 0, ...data };
    });

    this.state = {
      product: null,
      variant: null,
      imageIndex: 0,
      unit: 'in',
      isDragging: false,
      userCompact: false,
      gridBeforeProductOpen: false,
      filters: {
        sizes: new Set(),
        types: new Set(),
        collections: new Set()
      },
      sort: 'default'
    };

    this.feature = this.querySelector('[data-gu-feature]');
    this.news = this.querySelector('[data-gu-news]');
    this.footer = this.querySelector('[data-gu-footer]');
    this.featureImg = this.querySelector('[data-gu-feature-img]');
    this.featureImgNext = this.querySelector('[data-gu-feature-img-next]');
    this.gallery = this.querySelector('[data-gu-gallery]');
    this.galleryPrev = this.querySelector('[data-gu-gallery-prev]');
    this.galleryNext = this.querySelector('[data-gu-gallery-next]');
    this.dots = this.querySelector('[data-gu-dots]');
    this.featureTitle = this.querySelector('[data-gu-feature-title]');
    this.featurePrice = this.querySelector('[data-gu-feature-price]');
    this.sizeRow = this.querySelector('[data-gu-size-row]');
    this.info = this.querySelector('[data-gu-info]');
    this.addBtn = this.querySelector('[data-gu-add]');
    this.chartBtn = this.querySelector('[data-gu-help]');
    this.detailsBtn = this.querySelector('[data-gu-details]');
    this.actionsRow = this.addBtn?.closest('.gu-actions-row');
    this.drawer = this.querySelector('[data-gu-drawer]');
    this.overlay = this.querySelector('[data-gu-overlay]');
    this.cartItems = this.querySelector('[data-gu-cart-items]');
    this.cartScrollWrap = this.querySelector('[data-gu-cart-scroll-wrap]');
    this.cartScrollCue = this.querySelector('[data-gu-cart-scroll-cue]');
    this.cartCountEls = this.querySelectorAll('[data-gu-cart-count]');
    this.totalEl = this.querySelector('[data-gu-total]');
this.totalRow = this.querySelector('[data-gu-total-row]');
    this.controls = this.querySelector('[data-gu-controls]');
    this.sizeModal = this.querySelector('[data-gu-size-modal]');
    this.sizeTable = this.querySelector('[data-gu-size-table]');
    this.lightbox = this.querySelector('[data-gu-lightbox]');
    this.lightboxImg = this.querySelector('[data-gu-lightbox-img]');
    this.detailsModal = this.querySelector('[data-gu-details-modal]');
    this.detailsBody = this.querySelector('[data-gu-details-body]');
    this.shippingRow = this.querySelector('[data-gu-shipping-row]');
    this.checkoutLink = this.querySelector('[data-gu-checkout]');
    this.termsCheckbox = this.querySelector('[data-gu-terms]');
this.termsHint = this.querySelector('[data-gu-terms-hint]');

this.filterModal = this.querySelector('[data-gu-filter-modal]');
this.filterBody = this.querySelector('[data-gu-filter-body]');

this.filterClearButton = this.querySelector('[data-gu-clear-active-filter]');
    this.gridToggle = this.querySelector('[data-gu-toggle-grid]');
    this.modeToggle = this.querySelector('[data-gu-toggle-mode]');
    this.logoLink = this.querySelector('[data-gu-logo-link]');
    this.newsForm = this.querySelector('.gu-news-form');
    this.newsEmail = this.querySelector('[data-gu-news-email]');
    this.newsError = this.querySelector('[data-gu-news-error]');

    this.logoLink?.addEventListener('click', (event) => this.handleLogoClick(event));
    this.newsForm?.addEventListener('submit', (event) => this.handleNewsletterSubmit(event));
    this.newsEmail?.addEventListener('input', () => {
      if (this.newsError) this.newsError.hidden = true;
      this.newsEmail?.classList.remove('has-error');
    });
    this.gridToggle?.addEventListener('click', () => this.toggleCompactGrid());
    this.modeToggle?.addEventListener('click', () => this.toggleMode());
    this.querySelector('[data-gu-open-filter]')?.addEventListener('click', () => this.openFilter());
    this.querySelector('[data-gu-close-filter]')?.addEventListener('click', () => this.closeFilter());
    this.querySelector('[data-gu-clear-filter]')?.addEventListener('click', () => this.clearFilters());
    this.filterClearButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.clearFilters({ closeModal: true });
    });
    this.querySelector('[data-gu-apply-filter]')?.addEventListener('click', () => this.applyFiltersFromModal({ closeModal: true }));
    this.filterModal?.addEventListener('click', (event) => { if (event.target === this.filterModal) this.closeFilter(); });

    this.querySelector('[data-gu-zoom]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.showLightbox();
    });
    this.querySelector('[data-gu-close-lightbox]')?.addEventListener('click', () => this.hideLightbox());
    this.lightbox?.addEventListener('click', () => this.hideLightbox());
    this.querySelector('[data-gu-close-details]')?.addEventListener('click', () => this.closeDetails());
    this.detailsModal?.addEventListener('click', (event) => { if (event.target === this.detailsModal) this.closeDetails(); });
    this.checkoutLink?.addEventListener('click', (event) => this.handleCheckoutClick(event));

    this.querySelectorAll('[data-gu-open-product]').forEach((button) => {
      button.addEventListener('click', (event) => {
        if (button.dataset.dragged === 'true') {
          button.dataset.dragged = 'false';
          event.preventDefault();
          return;
        }
        this.openProduct(button.closest('[data-gu-product]')?.dataset.productId);
      });
    });

    this.querySelectorAll('[data-gu-card-variant]').forEach((button) => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    this.openProduct(button.closest('[data-gu-product]')?.dataset.productId, button.dataset.variantId);
  });
});

this.querySelectorAll('[data-gu-open-card-product]').forEach((button) => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    this.openProduct(button.closest('[data-gu-product]')?.dataset.productId);
  });
});

this.querySelectorAll('[data-gu-quick-add]').forEach((button) => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    this.quickAdd(button.dataset.variantId, button);
  });
});

    this.querySelector('[data-gu-close-product]')?.addEventListener('click', () => this.closeProduct());
    this.querySelector('[data-gu-help]')?.addEventListener('click', () => this.openSizeGuide());
    this.querySelector('[data-gu-details]')?.addEventListener('click', () => this.openDetails());
    this.addBtn?.addEventListener('click', () => this.addCurrentToCart());
    this.querySelectorAll('[data-gu-open-cart]').forEach((button) => button.addEventListener('click', () => this.openCart()));
    this.querySelectorAll('[data-gu-close-cart]').forEach((button) => button.addEventListener('click', () => this.closeCart()));
    this.overlay?.addEventListener('click', () => this.closeCart());
    this.querySelector('[data-gu-close-size]')?.addEventListener('click', () => this.closeSizeGuide());
    this.sizeModal?.addEventListener('click', (event) => { if (event.target === this.sizeModal) this.closeSizeGuide(); });

    this.querySelectorAll('[data-gu-unit-toggle] [data-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        this.state.unit = button.dataset.unit || 'in';
        this.querySelectorAll('[data-gu-unit-toggle] [data-unit]').forEach((b) => b.classList.toggle('is-active', b === button));
        this.renderSizeTable();
      });
    });

    this.galleryPrev?.addEventListener('pointerdown', (event) => event.stopPropagation());
    this.galleryNext?.addEventListener('pointerdown', (event) => event.stopPropagation());
    this.galleryPrev?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); this.moveImage(-1); });
    this.galleryNext?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); this.moveImage(1); });

    this.backToTop = this.querySelector('[data-gu-back-to-top]');
    this.backToTop?.addEventListener('click', () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      this.classList.remove('is-scrolled');
    });
    this.handleScrollState = () => {
  const scrolled = window.scrollY > 180;
  const stopTarget = this.querySelector('[data-gu-footer]') || this.querySelector('[data-gu-news]');
  const stopTop = stopTarget ? stopTarget.getBoundingClientRect().top + window.scrollY : Infinity;
  const pastStop = window.scrollY + window.innerHeight > stopTop - 18;

  this.classList.toggle('is-scrolled', scrolled && !pastStop);
};
    window.addEventListener('scroll', this.handleScrollState, { passive: true });
    this.handleScrollState();

    this.bindFeatureGallery();
    this.bindCardGalleries();
    this.preloadProductImages();
    this.initMode();
    this.buildFilterModal();
    this.filterBody?.addEventListener('change', () => this.applyFiltersFromModal({ closeModal: false }));
        this.updateFilterButtonState();
        this.renderCart();
    this.loadMoreButton = this.querySelector('[data-gu-load-more]');
    this.loadMoreWrap = this.querySelector('[data-gu-load-more-wrap]');
    this.bindLoadMore();
  }

  bindLoadMore() {
    if (!this.loadMoreButton) return;

    this.loadMoreButton.addEventListener('click', async () => {
      const nextUrl = this.loadMoreButton.dataset.nextUrl;
      if (!nextUrl || this.loadMoreButton.classList.contains('is-loading')) return;

      this.loadMoreButton.classList.add('is-loading');
      this.loadMoreButton.textContent = 'LOADING';

      try {
        const response = await fetch(nextUrl);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const nextPage = doc.querySelector('greedy-one-page-shop');
        const nextGrid = nextPage?.querySelector('[data-gu-grid]');
        const currentGrid = this.querySelector('[data-gu-grid]');

        if (!nextGrid || !currentGrid) {
          this.loadMoreButton.textContent = 'NO MORE';
          return;
        }

        const newCards = [...nextGrid.querySelectorAll('[data-gu-product]')];

        newCards.forEach((card) => {
          currentGrid.appendChild(card);

          const jsonEl = card.querySelector('[data-gu-product-json]');
          let data = {};
          try {
            data = JSON.parse(jsonEl?.textContent || '{}');
          } catch (e) {
            console.error('Bad product JSON on loaded product', e);
          }

          this.products.push({
            card,
            cardImageIndex: 0,
            ...data
          });

          const openButton = card.querySelector('[data-gu-open-product]');
          openButton?.addEventListener('click', (event) => {
            if (openButton.dataset.dragged === 'true') {
              openButton.dataset.dragged = 'false';
              event.preventDefault();
              return;
            }
            this.openProduct(card.dataset.productId);
          });

          card.querySelectorAll('[data-gu-card-variant]').forEach((button) => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    this.openProduct(card.dataset.productId, button.dataset.variantId);
  });
});

card.querySelectorAll('[data-gu-open-card-product]').forEach((button) => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    this.openProduct(card.dataset.productId);
  });
});

card.querySelectorAll('[data-gu-quick-add]').forEach((button) => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    this.quickAdd(button.dataset.variantId, button);
  });
});
        });

                this.bindCardGalleries();
        this.preloadProductImages();
        this.buildFilterModal();
        this.updateFilterButtonState();

        const nextButton = nextPage.querySelector('[data-gu-load-more]');

        if (nextButton?.dataset.nextUrl) {
          this.loadMoreButton.dataset.nextUrl = nextButton.dataset.nextUrl;
          this.loadMoreButton.classList.remove('is-loading');
          this.loadMoreButton.textContent = 'LOAD MORE';
        } else {
          this.loadMoreWrap?.remove();
          this.loadMoreButton = null;
        }
      } catch (error) {
        console.error('Load more failed', error);
        this.loadMoreButton.classList.remove('is-loading');
        this.loadMoreButton.textContent = 'TRY AGAIN';
      }
    });
  }

  handleNewsletterSubmit(event) {
    if (!this.newsEmail) return;
    const value = (this.newsEmail.value || '').trim();
    const isValid = !!value && this.newsEmail.checkValidity();
    if (!isValid) {
      event.preventDefault();
      event.stopPropagation();
      this.newsEmail.classList.add('has-error');
      if (this.newsError) this.newsError.hidden = false;
      this.newsEmail.focus({ preventScroll: true });
    }
  }

  money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
  }

  handleLogoClick(event) {
    const targetPath = new URL(this.logoLink?.href || '/', window.location.origin).pathname.replace(/\/$/, '') || '/';
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

    const filterIsOpen = this.filterModal && !this.filterModal.hidden;

    const hasActiveFilters = !!(
      this.state.filters.sizes.size ||
      this.state.filters.types.size ||
      this.state.filters.collections.size ||
      this.state.sort !== 'default'
    );

    if (filterIsOpen) {
      event.preventDefault();
      this.closeFilter();
      this.smoothScrollTo(0, 420);
      return;
    }

    if (hasActiveFilters) {
      event.preventDefault();
      this.clearFilters({ closeModal: true });
      this.smoothScrollTo(0, 420);
      return;
    }

    if (this.classList.contains('is-product-open')) {
      event.preventDefault();
      window.location.href = this.logoLink?.href || '/';
      return;
    }

    if (currentPath === targetPath || currentPath === '/') {
      event.preventDefault();
      this.smoothScrollTo(0, 420);
    }
  }

  smoothScrollTo(targetY, duration = 420) {
    const startY = window.scrollY || window.pageYOffset || 0;
    const distance = Math.max(0, targetY) - startY;
    const startTime = performance.now();
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    const step = (now) => {
      const progress = Math.min(1, (now - startTime) / duration);
      window.scrollTo(0, startY + distance * ease(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  initMode() {
  const saved = localStorage.getItem('gu_color_mode');
  const dark = saved === 'dark';
  this.classList.toggle('is-dark', dark);
  document.documentElement.classList.toggle('gu-document-dark', dark);
  document.body?.classList.toggle('gu-document-dark', dark);
  if (this.modeToggle) {
    this.modeToggle.classList.toggle('is-moon-active', dark);
    this.modeToggle.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
    this.modeToggle.setAttribute('aria-pressed', dark ? 'true' : 'false');
  }

  this.forceLoadFonts();
}

forceLoadFonts() {
  if (!document.fonts || !document.fonts.forEach) return;

  const fontsToLoad = [];

  document.fonts.forEach((f) => {
    if (f.status === 'unloaded') {
      fontsToLoad.push(f);
    }
  });

  fontsToLoad.forEach((f) => {
    f.load().catch((err) => {
      console.warn('Font load failed:', f.family, err);
    });
  });
}

  toggleMode() {
  const dark = !this.classList.contains('is-dark');
  this.classList.toggle('is-dark', dark);
  document.documentElement.classList.toggle('gu-document-dark', dark);
  document.body?.classList.toggle('gu-document-dark', dark);
  localStorage.setItem('gu_color_mode', dark ? 'dark' : 'light');
  if (this.modeToggle) {
  this.modeToggle.classList.toggle('is-moon-active', dark);
  this.modeToggle.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
  this.modeToggle.setAttribute('aria-pressed', dark ? 'true' : 'false');
}
}

  updateGridToggleText() {
  if (!this.gridToggle) return;
  this.gridToggle.textContent = this.state.userCompact
    ? (this.dataset.gridMinusLabel || 'GRID -')
    : (this.dataset.gridPlusLabel || 'GRID +');
  this.gridToggle.setAttribute('aria-pressed', this.state.userCompact ? 'true' : 'false');
}

  buildFilterModal() {
    if (!this.filterBody) return;

    const sizes = new Map();
    const types = new Map();

    this.products.forEach((product) => {
  const options = Array.isArray(product.options) ? product.options : [];
  const variants = Array.isArray(product.variants) ? product.variants : [];

  const sizeOptionIndex = options.findIndex((option) => {
    const name = String(option?.name || '').trim().toLowerCase();
    return name === 'size' || name === 'sizes';
  });

  if (sizeOptionIndex >= 0) {
    const sizeOption = options[sizeOptionIndex];
    const sizeValues = Array.isArray(sizeOption.values) ? sizeOption.values : [];

    sizeValues.forEach((sizeValue) => {
      const cleanSize = String(sizeValue || '').trim();
      if (!cleanSize) return;

      const hasAvailable = variants.some((variant) => {
        if (!variant.available) return false;

        if (sizeOptionIndex === 0) return String(variant.option1 || '').trim() === cleanSize;
        if (sizeOptionIndex === 1) return String(variant.option2 || '').trim() === cleanSize;
        if (sizeOptionIndex === 2) return String(variant.option3 || '').trim() === cleanSize;

        return false;
      });

      if (!sizes.has(cleanSize)) sizes.set(cleanSize, false);
      if (hasAvailable) sizes.set(cleanSize, true);
    });
  }

  (product.tags || []).forEach((tag) => {
        const rawTag = String(tag || '').trim();
        const prefix = 'type:';
        if (!rawTag.toLowerCase().startsWith(prefix)) return;
        const rawType = rawTag.slice(prefix.length).trim();
        if (!rawType) return;
        const handle = rawType.toLowerCase().replace(/\s+/g, '-');
        const label = rawType.replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
        types.set(handle, label);
      });
    });

    const sizeHtml = [...sizes].map(([size, hasAvailable]) => `
      <label class="${hasAvailable ? '' : 'is-disabled'}">
        <input type="checkbox" data-filter-size value="${this.escapeHtml(size)}" ${hasAvailable ? '' : 'disabled'}>
        ${this.escapeHtml(size)}
      </label>
    `).join('') || '<div class="gu-filter-empty">NO SIZES FOUND.</div>';

    const sortedTypes = [...types].sort((a, b) => a[1].localeCompare(b[1]));

    const typeHtml = sortedTypes.map(([handle, label]) => `
      <label>
        <input type="checkbox" data-filter-type value="${this.escapeHtml(handle)}">
        ${this.escapeHtml(label)}
      </label>
    `).join('') || '<div class="gu-filter-empty">NO TYPES FOUND.</div>';

    const sortHtml = `
      <label><input type="radio" name="gu-sort" data-filter-sort value="default" checked> Default</label>
      <label><input type="radio" name="gu-sort" data-filter-sort value="price-asc"> Price Low To High</label>
      <label><input type="radio" name="gu-sort" data-filter-sort value="price-desc"> Price High To Low</label>
    `;

    this.filterBody.innerHTML = `
      <div class="gu-filter-group">
        <div class="gu-filter-label">SIZES</div>
        ${sizeHtml}
      </div>
      <div class="gu-filter-group">
        <div class="gu-filter-label">TYPE</div>
        ${typeHtml}
      </div>
      <div class="gu-filter-group gu-filter-group-sort">
        <div class="gu-filter-label">SORT</div>
        ${sortHtml}
      </div>
    `;
  }
  openFilter() {
    if (!this.filterModal) return;

    this.filterBody?.querySelectorAll('[data-filter-size]').forEach((box) => {
      box.checked = this.state.filters.sizes.has(box.value);
    });
    this.filterBody?.querySelectorAll('[data-filter-type]').forEach((box) => {
      box.checked = this.state.filters.types.has(box.value);
    });
    this.filterBody?.querySelectorAll('[data-filter-sort]').forEach((radio) => {
      radio.checked = radio.value === this.state.sort;
    });

    this.filterModal.hidden = false;
    this.updateModalState();
  }

  closeFilter() {
    if (this.filterModal) this.filterModal.hidden = true;
    this.updateModalState();
  }

  updateModalState() {
  const anyOpen = !!(
    (this.filterModal && !this.filterModal.hidden) ||
    (this.sizeModal && !this.sizeModal.hidden) ||
    (this.detailsModal && !this.detailsModal.hidden)
  );

  this.classList.toggle('is-modal-open', anyOpen);
}

  clearFilters(options = {}) {
    this.state.filters.sizes.clear();
    this.state.filters.types.clear();
    this.state.filters.collections.clear();
    this.state.sort = 'default';

    this.filterBody?.querySelectorAll('input[type="checkbox"]').forEach((box) => { box.checked = false; });
    this.filterBody?.querySelectorAll('[data-filter-sort]').forEach((radio) => {
      radio.checked = radio.value === 'default';
    });

    this.applyFilters();
    this.updateFilterButtonState();

    if (options.closeModal !== false) this.closeFilter();
  }

  applyFiltersFromModal(options = {}) {
    this.state.filters.sizes = new Set(
      [...this.filterBody.querySelectorAll('[data-filter-size]:checked')].map((box) => box.value)
    );
    this.state.filters.types = new Set(
      [...this.filterBody.querySelectorAll('[data-filter-type]:checked')].map((box) => box.value)
    );
    const selectedSort = this.filterBody.querySelector('[data-filter-sort]:checked');
    this.state.sort = selectedSort?.value || 'default';

    this.applyFilters();
    this.updateFilterButtonState();
    if (options.closeModal !== false) this.closeFilter();
  }

  applyFilters() {
    const selectedSizes = this.state.filters.sizes;
    const selectedTypes = this.state.filters.types;

    this.products.forEach((product) => {
      const options = Array.isArray(product.options) ? product.options : [];
const variants = Array.isArray(product.variants) ? product.variants : [];

const sizeOptionIndex = options.findIndex((option) => {
  const name = String(option?.name || '').trim().toLowerCase();
  return name === 'size' || name === 'sizes';
});

const sizeMatch = !selectedSizes.size || (
  sizeOptionIndex >= 0 &&
  variants.some((variant) => {
    if (!variant.available) return false;

    let variantSize = '';

    if (sizeOptionIndex === 0) variantSize = variant.option1;
    if (sizeOptionIndex === 1) variantSize = variant.option2;
    if (sizeOptionIndex === 2) variantSize = variant.option3;

    return selectedSizes.has(String(variantSize || '').trim());
  })
);

      const productTypes = (product.tags || [])
        .map((tag) => String(tag || '').trim())
        .filter((tag) => tag.toLowerCase().startsWith('type:'))
        .map((tag) => tag.slice('type:'.length).trim())
        .filter((tag) => tag)
        .map((tag) => tag.toLowerCase().replace(/\s+/g, '-'));

      const typeMatch = !selectedTypes.size || productTypes.some((type) => selectedTypes.has(type));

      product.card.hidden = !(sizeMatch && typeMatch);
    });

    this.sortProducts();
    this.updateFilterEmptyState();
    this.updateFilterButtonState();
  }

  sortProducts() {
    const grid = this.querySelector('[data-gu-grid]');
    if (!grid) return;

    const sortedProducts = [...this.products];

    const getProductPrice = (product) => {
      const prices = (product.variants || [])
        .map((variant) => Number(variant.price || 0))
        .filter((price) => price > 0);
      return prices.length ? Math.min(...prices) : 0;
    };

    if (this.state.sort === 'price-asc') {
      sortedProducts.sort((a, b) => getProductPrice(a) - getProductPrice(b));
    }
    if (this.state.sort === 'price-desc') {
      sortedProducts.sort((a, b) => getProductPrice(b) - getProductPrice(a));
    }
    if (this.state.sort === 'default') {
      sortedProducts.sort((a, b) => this.products.indexOf(a) - this.products.indexOf(b));
    }

    sortedProducts.forEach((product) => grid.appendChild(product.card));
  }

  updateFilterButtonState() {
    const hasActiveFilters = !!(
      this.state.filters.sizes.size ||
      this.state.filters.types.size ||
      this.state.filters.collections.size ||
      this.state.sort !== 'default'
    );
    this.classList.toggle('has-active-filters', hasActiveFilters);
    if (this.filterClearButton) this.filterClearButton.hidden = !hasActiveFilters;
  }

  updateFilterEmptyState() {
    const grid = this.querySelector('[data-gu-grid]');
    if (!grid) return;

    let emptyState = grid.querySelector('[data-gu-filter-empty-state]');

    if (!emptyState) {
      emptyState = document.createElement('div');
      emptyState.className = 'gu-filter-empty-state';
      emptyState.setAttribute('data-gu-filter-empty-state', '');
      emptyState.innerHTML = `
        <div class="gu-filter-empty-title">COMBINATION NOT AVAILABLE.</div>
        <button type="button" data-gu-clear-empty-filter>CLICK HERE TO CLEAR FILTERS</button>
      `;
      emptyState.querySelector('[data-gu-clear-empty-filter]')?.addEventListener('click', () => {
        this.clearFilters({ closeModal: true });
        this.smoothScrollTo(0, 320);
      });
      grid.appendChild(emptyState);
    }

    const hasActiveFilters = !!(
      this.state.filters.sizes.size ||
      this.state.filters.types.size ||
      this.state.filters.collections.size
    );

    const visibleProducts = this.products.filter((product) => !product.card.hidden);

    emptyState.hidden = !(hasActiveFilters && visibleProducts.length === 0);
  }

  preloadProductImages() {
    this.products.forEach((product) => {
      this.getImages(product).slice(0, 4).forEach((img) => {
        if (!img?.src) return;
        const pre = new Image();
        pre.src = img.src;
      });
    });
  }

  /* Issue 4: GRID +/- toggle.
     If product is open on desktop, clicking the toggle just closes it.
     Otherwise, flip compact mode and update the label. */
  toggleCompactGrid(force) {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    if (this.classList.contains('is-product-open') && !isMobile) {
      this.closeProduct();
      return;
    }
    const next = typeof force === 'boolean' ? force : !this.state.userCompact;
    this.state.userCompact = next;
    this.classList.toggle('is-grid-compact', next);
    this.updateGridToggleText();
  }

  getProduct(productId) {
    return this.products.find((p) => String(p.id) === String(productId));
  }

  getVariant(product, variantId) {
    if (!product?.variants?.length) return null;
    if (variantId) return product.variants.find((v) => String(v.id) === String(variantId)) || product.variants[0];
    return product.variants.find((v) => v.available) || product.variants[0];
  }

  /* Issue 4 fix:
     - Save the prior compact state so closeProduct() can restore it.
     - When opening, force is-grid-compact OFF so the halfscreen-open-columns
       rule wins, and reset the GRID toggle label back to "GRID +". */
  openProduct(productId, variantId = null) {
    const product = this.getProduct(productId);
    if (!product) return;

    const currentlyOpen = this.classList.contains('is-product-open');
    const sameProduct = this.state.product && String(this.state.product.id) === String(product.id);
    const sameVariant = !variantId || (this.state.variant && String(this.state.variant.id) === String(variantId));

    if (currentlyOpen && sameProduct && sameVariant) {
      this.closeProduct();
      return;
    }

    if (!currentlyOpen) {
      this.state.gridBeforeProductOpen = this.state.userCompact;
    }

    this.state.userCompact = false;
    this.classList.remove('is-grid-compact');
    this.updateGridToggleText();

    this.feature.hidden = false;
    this.classList.add('is-product-open');

    if (this.featureImg) {
      this.featureImg.removeAttribute('src');
      this.featureImg.alt = '';
    }
    this.featureTitle.textContent = '...';
    this.featurePrice.textContent = '';
    this.sizeRow.innerHTML = '';

    this.state.product = product;
    this.state.variant = this.getVariant(product, variantId);
    this.state.imageIndex = 0;

    this.querySelectorAll('[data-gu-product]').forEach((card) => {
      card.classList.toggle('is-selected', String(card.dataset.productId) === String(product.id));
    });
    this.info.hidden = true;
    this.closeDetails();
    this.renderFeature({ isProductOpen: true });

    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    const isFullscreenDesktop = !isMobile && this.classList.contains('gu-feature-mode-fullscreen');
    if (isMobile || isFullscreenDesktop) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0, behavior: 'auto' }));
    }
  }

  closeProduct() {
    this.classList.remove('is-product-open', 'has-real-variants-open', 'has-no-real-variants-open');
    // Restore prior compact state.
    this.classList.toggle('is-grid-compact', !!this.state.gridBeforeProductOpen);
    this.state.userCompact = !!this.state.gridBeforeProductOpen;
    this.updateGridToggleText();
    this.querySelectorAll('[data-gu-product]').forEach((card) => card.classList.remove('is-selected'));
    if (this.feature) this.feature.hidden = true;
    this.state.product = null;
    this.state.variant = null;
    this.hideLightbox();
    this.closeDetails();
  }

  renderFeature(options = {}) {
    const p = this.state.product;
    if (!p) return;

    const isProductOpen = options.isProductOpen === true;

    const selected = this.state.variant || this.getVariant(p);
    const selectedImage = selected?.image;
    const images = this.getImages(p);

    let nextSrc = '';
    let nextIndex = this.state.imageIndex;

    if (selectedImage) {
      const matchIndex = images.findIndex((img) => img && img.src === selectedImage);

      if (matchIndex >= 0) {
        nextIndex = matchIndex;
        nextSrc = selectedImage;
      } else {
        nextSrc = selectedImage;
      }
    } else {
      nextSrc = (images[this.state.imageIndex] || images[0])?.src || '';
    }

    this.state.imageIndex = nextIndex;

    this.setFeatureImage(nextSrc, p.title || '');

    this.featureTitle.textContent = p.title || '';

    if (selected?.compareAtPrice && Number(selected.compareAtPrice) > Number(selected.price)) {
      this.featurePrice.innerHTML = `
        <span class="gu-price-sale">${this.escapeHtml(this.money(selected.price))}</span>
        <span class="gu-price-compare">${this.escapeHtml(this.money(selected.compareAtPrice))}</span>
      `;
    } else {
      this.featurePrice.innerHTML = selected?.price
        ? `<span class="gu-price-sale">${this.escapeHtml(this.money(selected.price))}</span>`
        : '';
    }

    const hasSizeChart = !!(
      p.sizeChart &&
      Array.isArray(p.sizeChart.columns) &&
      p.sizeChart.columns.length &&
      Array.isArray(p.sizeChart.sizes) &&
      p.sizeChart.sizes.length
    );

    const hasRealVariants = Array.isArray(p.variants) && (
      p.variants.length > 1 ||
      (p.variants[0] && p.variants[0].title && p.variants[0].title !== 'Default Title')
    );

    this.classList.toggle('has-real-variants-open', !!hasRealVariants);
    this.classList.toggle('has-no-real-variants-open', !hasRealVariants);

    if (this.chartBtn) this.chartBtn.hidden = !hasSizeChart;

    const hasDetails = !!((p.descriptionHtml || '').trim() || (p.description || '').trim());
    if (this.detailsBtn) this.detailsBtn.hidden = !hasDetails;

    if (this.actionsRow) {
      this.actionsRow.classList.remove('is-details-only', 'is-no-variants-no-chart', 'is-variants-no-chart', 'is-no-details');
      if (!hasDetails) this.actionsRow.classList.add('is-no-details');
      if (!hasSizeChart && !hasRealVariants) this.actionsRow.classList.add('is-no-variants-no-chart');
      if (!hasSizeChart && hasRealVariants) this.actionsRow.classList.add('is-variants-no-chart');
    }

    this.renderDots(images.length);

    const hasMultipleImages = images.length > 1;
    this.classList.toggle('has-multiple-images', hasMultipleImages);
    this.classList.toggle('has-single-image', !hasMultipleImages);

    this.sizeRow.innerHTML = '';
this.sizeRow.hidden = !hasRealVariants;

if (hasRealVariants) {
  const options = Array.isArray(p.options) ? p.options : [];
  const variants = Array.isArray(p.variants) ? p.variants : [];

  const selectedOptions = [
    selected?.option1 || '',
    selected?.option2 || '',
    selected?.option3 || ''
  ];

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const getOptionValue = (variant, optionIndex) => {
    if (optionIndex === 0) return variant.option1 || '';
    if (optionIndex === 1) return variant.option2 || '';
    if (optionIndex === 2) return variant.option3 || '';
    return '';
  };

  const isSizeOption = (option) => {
    const name = normalize(option?.name || '');
    return name === 'size' || name === 'sizes';
  };

  const sizeOptionIndex = options.findIndex((option) => isSizeOption(option));

  const variantMatchesValue = (variant, optionIndex, value) => {
    return normalize(getOptionValue(variant, optionIndex)) === normalize(value);
  };

  const variantMatchesCurrentSelectionExcept = (variant, optionIndex) => {
    return selectedOptions.every((selectedValue, selectedIndex) => {
      if (selectedIndex === optionIndex) return true;
      if (!selectedValue) return true;

      return normalize(getOptionValue(variant, selectedIndex)) === normalize(selectedValue);
    });
  };

  const valueHasAnyAvailableVariant = (optionIndex, value) => {
    return variants.some((variant) => {
      return variant.available && variantMatchesValue(variant, optionIndex, value);
    });
  };

  const valueHasContextualAvailableVariant = (optionIndex, value) => {
    return variants.some((variant) => {
      return variant.available &&
        variantMatchesValue(variant, optionIndex, value) &&
        variantMatchesCurrentSelectionExcept(variant, optionIndex);
    });
  };

  const valueHasAnyVariantAtAll = (optionIndex, value) => {
    return variants.some((variant) => {
      return variantMatchesValue(variant, optionIndex, value);
    });
  };

  const findFirstAvailableVariantForSize = (optionIndex, value) => {
    return variants.find((variant) => {
      return variant.available && variantMatchesValue(variant, optionIndex, value);
    });
  };

  const findContextualAvailableVariant = (optionIndex, value) => {
    return variants.find((variant) => {
      return variant.available &&
        variantMatchesValue(variant, optionIndex, value) &&
        variantMatchesCurrentSelectionExcept(variant, optionIndex);
    });
  };

  const findContextualVariantEvenIfSoldOut = (optionIndex, value) => {
    return variants.find((variant) => {
      return variantMatchesValue(variant, optionIndex, value) &&
        variantMatchesCurrentSelectionExcept(variant, optionIndex);
    });
  };

  const findAnyVariantForValue = (optionIndex, value) => {
    return variants.find((variant) => {
      return variantMatchesValue(variant, optionIndex, value);
    });
  };

  const findTargetVariant = (option, optionIndex, value) => {
    if (isSizeOption(option)) {
      return findFirstAvailableVariantForSize(optionIndex, value) ||
        findAnyVariantForValue(optionIndex, value);
    }

    return findContextualAvailableVariant(optionIndex, value) ||
      findContextualVariantEvenIfSoldOut(optionIndex, value) ||
      findAnyVariantForValue(optionIndex, value);
  };

  options.forEach((option, optionIndex) => {
    const row = document.createElement('div');
    row.className = 'gu-option-row';
    row.dataset.optionName = option.name || '';

    const values = Array.isArray(option.values) ? option.values : [];

    values.forEach((value) => {
      const targetVariant = findTargetVariant(option, optionIndex, value);
      const isSelected = normalize(selectedOptions[optionIndex]) === normalize(value);

      let isAvailable = false;

      if (isSizeOption(option)) {
        isAvailable = valueHasAnyAvailableVariant(optionIndex, value);
      } else if (sizeOptionIndex >= 0 && selectedOptions[sizeOptionIndex]) {
        isAvailable = valueHasContextualAvailableVariant(optionIndex, value);
      } else {
        isAvailable = valueHasAnyAvailableVariant(optionIndex, value);
      }

      const existsAtAll = valueHasAnyVariantAtAll(optionIndex, value);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gu-size' + (isSelected ? ' is-selected' : '') + (!isAvailable ? ' is-unavailable' : '');
      button.textContent = value;

      if (!targetVariant || !existsAtAll) {
        button.disabled = true;
      }

      button.addEventListener('click', () => {
        if (!targetVariant) return;
        this.state.variant = targetVariant;
        this.renderFeature();
      });

      row.appendChild(button);
    });

    if (row.children.length) {
      this.sizeRow.appendChild(row);
    }
  });
}

        this.addBtn.disabled = !selected?.available;
    this.addBtn.textContent = selected?.available ? 'ADD' : (this.dataset.soldOutText || 'SOLD OUT');

  }

  setFeatureImage(src, alt = '') {
    if (!this.featureImg) return;
    this.gallery?.classList.remove('is-loading');
    const img = this.featureImg;
    const nextSrc = src || '';

    if (!nextSrc) {
      img.removeAttribute('src');
      img.alt = alt;
    } else {
      img.alt = alt;
      img.src = nextSrc;
    }

    img.classList.remove('is-slide-out-left', 'is-slide-out-right', 'is-slide-in-left', 'is-slide-in-right');
    img.style.transform = '';
    img.style.opacity = '';
    if (this.featureImgNext) {
      this.featureImgNext.removeAttribute('src');
      this.featureImgNext.style.opacity = '';
      this.featureImgNext.style.transform = '';
    }
  }

  getImages(product) {
    const images = Array.isArray(product?.images) ? product.images.filter((img) => img.src) : [];
    return images.length ? images : [{ src: '', alt: product?.title || '' }];
  }

  renderDots(count) {
    if (!this.dots) return;
    this.dots.innerHTML = '';

    const style = this.dataset.galleryNavStyle || 'dots';

    if (style === 'numbers' || style === 'numbers_parentheses') {
      const counter = document.createElement('button');
      counter.type = 'button';
      counter.className = 'gu-gallery-count';
      const text = `${Math.min(this.state.imageIndex + 1, count)}/${count}`;
      counter.textContent = style === 'numbers_parentheses' ? `(${text})` : text;
      counter.setAttribute('aria-label', `Image ${this.state.imageIndex + 1} of ${count}`);
      counter.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.moveImage(1);
      });
      this.dots.appendChild(counter);
      return;
    }

    for (let i = 0; i < count; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'gu-dot' + (i === this.state.imageIndex ? ' is-active' : '');
      dot.setAttribute('aria-label', `Show image ${i + 1}`);
      dot.setAttribute('aria-pressed', i === this.state.imageIndex ? 'true' : 'false');
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.goToImage(i);
      });
      this.dots.appendChild(dot);
    }
  }

  goToImage(index) {
    const images = this.getImages(this.state.product);
    if (!images.length) return;
    const nextIndex = ((index % images.length) + images.length) % images.length;
    if (nextIndex === this.state.imageIndex) return;
    this.state.imageIndex = nextIndex;
    const img = images[this.state.imageIndex];
    this.setFeatureImage(img?.src || '', this.state.product?.title || '');
    this.renderDots(images.length);
    if (!this.lightbox?.hidden) this.showLightbox();
  }

  moveImage(direction) {
    const images = this.getImages(this.state.product);
    if (!images.length) return;
    const nextIndex = (this.state.imageIndex + direction + images.length) % images.length;
    this.state.imageIndex = nextIndex;
    const img = images[this.state.imageIndex];
    this.setFeatureImage(img?.src || '', this.state.product?.title || '');
    this.renderDots(images.length);
    if (!this.lightbox?.hidden) this.showLightbox();
  }

  bindFeatureGallery() {
  if (!this.gallery || !this.featureImg || !this.featureImgNext) return;

  let startX = 0;
  let currentX = 0;
  let isDown = false;
  let pointerId = null;
  let dragDirection = 0;
  let didDrag = false;

  const images = () => this.getImages(this.state.product).filter((img) => img && img.src);

  const getWidth = () => {
    return Math.max(1, this.gallery.getBoundingClientRect().width || this.gallery.clientWidth || 1);
  };

  const getNextIndex = (direction) => {
    const list = images();
    return (this.state.imageIndex + direction + list.length) % list.length;
  };

  const getNextImage = (direction) => {
    const list = images();
    if (list.length < 2) return null;
    return list[getNextIndex(direction)] || null;
  };

  const hideNext = () => {
    this.featureImgNext.style.transition = 'none';
    this.featureImgNext.style.opacity = '0';
    this.featureImgNext.style.visibility = 'hidden';
    this.featureImgNext.style.transform = 'translate3d(0,0,0)';
    this.featureImgNext.src = '';
  };

  const resetPositions = () => {
    this.featureImg.style.transition = 'none';
    this.featureImg.style.transform = 'translate3d(0,0,0)';
    hideNext();
    this.gallery.classList.remove('is-dragging-gallery');
    dragDirection = 0;
  };

  const setNextLayer = (direction, delta) => {
    const nextImage = getNextImage(direction);
    if (!nextImage || !nextImage.src) return;

    const width = getWidth();

    if (dragDirection !== direction || this.featureImgNext.getAttribute('src') !== nextImage.src) {
  dragDirection = direction;

  this.featureImgNext.removeAttribute('srcset');
  this.featureImgNext.removeAttribute('sizes');

  this.featureImgNext.src = nextImage.src;
  this.featureImgNext.alt = nextImage.alt || this.state.product?.title || '';
}

    this.featureImgNext.style.transition = 'none';
    this.featureImgNext.style.opacity = '1';
    this.featureImgNext.style.visibility = 'visible';
    this.featureImgNext.style.transform = `translate3d(${direction > 0 ? width + delta : -width + delta}px,0,0)`;
  };

  const moveLayers = (delta) => {
    const list = images();
    if (list.length < 2) return;

    const width = getWidth();
    const limited = Math.max(-width, Math.min(width, delta));
    const direction = limited < 0 ? 1 : -1;

    this.gallery.classList.add('is-dragging-gallery');

    this.featureImg.style.transition = 'none';
    this.featureImgNext.style.transition = 'none';

    this.featureImg.style.transform = `translate3d(${limited}px,0,0)`;
    setNextLayer(direction, limited);
  };

  const commitImage = (direction) => {
    const list = images();
    if (list.length < 2) return;

    const nextIndex = getNextIndex(direction);
    const nextImage = list[nextIndex];

    if (!nextImage || !nextImage.src) {
      resetPositions();
      return;
    }

    this.state.imageIndex = nextIndex;

    this.featureImg.removeAttribute('srcset');
this.featureImg.removeAttribute('sizes');

this.featureImg.src = nextImage.src;
this.featureImg.alt = nextImage.alt || this.state.product?.title || '';

    this.renderDots(list.length);

    if (!this.lightbox?.hidden) this.showLightbox();

    resetPositions();
  };

  const snapBack = () => {
    const width = getWidth();
    const direction = dragDirection || ((currentX - startX) < 0 ? 1 : -1);

    this.featureImg.style.transition = 'transform 120ms ease-out';
    this.featureImg.style.transform = 'translate3d(0,0,0)';

    this.featureImgNext.style.transition = 'transform 120ms ease-out, opacity 120ms ease-out';
    this.featureImgNext.style.transform = `translate3d(${direction > 0 ? width : -width}px,0,0)`;
    this.featureImgNext.style.opacity = '0';

    window.setTimeout(resetPositions, 130);
  };

  const finish = () => {
    if (!isDown) return;

    isDown = false;

    const delta = currentX - startX;
    const threshold = 20;

    if (Math.abs(delta) > threshold) {
      commitImage(delta < 0 ? 1 : -1);
    } else {
      snapBack();
    }

    if (pointerId !== null) {
      try { this.gallery.releasePointerCapture?.(pointerId); } catch (e) {}
    }

    pointerId = null;
  };

  this.gallery.addEventListener('pointerdown', (event) => {
    if (event.target?.closest?.('[data-gu-zoom], .gu-gallery-arrow, .gu-dot')) return;

    const list = images();
    if (list.length < 2) return;

    isDown = true;
    didDrag = false;
    pointerId = event.pointerId;
    startX = event.clientX;
    currentX = event.clientX;
    dragDirection = 0;
    this.state.galleryDragged = false;

    this.featureImg.style.transition = 'none';
    this.featureImgNext.style.transition = 'none';

    try { this.gallery.setPointerCapture?.(event.pointerId); } catch (e) {}
  });

  this.gallery.addEventListener('pointermove', (event) => {
    if (!isDown) return;

    currentX = event.clientX;
    const delta = currentX - startX;

    if (Math.abs(delta) > 3) {
      didDrag = true;
      this.state.galleryDragged = true;
      event.preventDefault();
    }

    moveLayers(delta);
  });

  this.gallery.addEventListener('pointerup', finish);
  this.gallery.addEventListener('pointercancel', finish);

  this.gallery.addEventListener('click', (event) => {
    if (event.target?.closest?.('[data-gu-zoom], .gu-gallery-arrow, .gu-dot')) return;

    if (didDrag || this.state.galleryDragged) {
      didDrag = false;
      this.state.galleryDragged = false;
      event.preventDefault();
      return;
    }

    this.showLightbox();
  });
}

  bindCardGalleries() {
  this.products.forEach((product) => {
    const gallery = product.card.querySelector('[data-gu-card-gallery]');
    const imgEl = product.card.querySelector('.gu-card-img');
    const mainButton = product.card.querySelector('[data-gu-open-product]');
    const prev = product.card.querySelector('[data-gu-card-prev]');
    const next = product.card.querySelector('[data-gu-card-next]');

    if (!gallery || !imgEl) return;
    if (gallery.dataset.guGalleryBound === 'true') return;

    gallery.dataset.guGalleryBound = 'true';

    const images = () => this.getImages(product).filter((img) => img && img.src);
    if (images().length < 2) return;

    let nextImg = gallery.querySelector('.gu-card-img-next');

    if (!nextImg) {
      nextImg = document.createElement('img');
      nextImg.className = 'gu-card-img-next';
      nextImg.alt = '';
      nextImg.setAttribute('aria-hidden', 'true');
      gallery.appendChild(nextImg);
    }

    let startX = 0;
    let currentX = 0;
    let isDown = false;
    let pointerId = null;
    let dragDirection = 0;

    const getWidth = () => {
      return Math.max(1, gallery.getBoundingClientRect().width || gallery.clientWidth || 1);
    };

    const markDragged = (time = 350) => {
      if (!mainButton) return;

      mainButton.dataset.dragged = 'true';

      window.clearTimeout(mainButton._guDraggedTimer);
      mainButton._guDraggedTimer = window.setTimeout(() => {
        mainButton.dataset.dragged = 'false';
      }, time);
    };

    const getCurrentIndex = () => Number(product.cardImageIndex || 0);

    const getNextIndex = (direction) => {
      const list = images();
      return (getCurrentIndex() + direction + list.length) % list.length;
    };

    const getNextImage = (direction) => {
      const list = images();
      if (list.length < 2) return null;
      return list[getNextIndex(direction)] || null;
    };

    const hideNext = () => {
      nextImg.style.transition = 'none';
      nextImg.style.opacity = '0';
      nextImg.style.visibility = 'hidden';
      nextImg.style.transform = 'translate3d(0,0,0)';
      nextImg.src = '';
    };

    const resetPositions = () => {
      gallery.classList.remove('is-dragging-card');

      imgEl.style.transition = 'none';
      imgEl.style.transform = 'translate3d(0,0,0)';
      imgEl.style.opacity = '1';

      hideNext();

      dragDirection = 0;
    };

    const setNextLayer = (direction, delta) => {
      const nextImage = getNextImage(direction);
      if (!nextImage || !nextImage.src) return;

      const width = getWidth();

      if (dragDirection !== direction || nextImg.getAttribute('src') !== nextImage.src) {
  dragDirection = direction;

  nextImg.removeAttribute('srcset');
  nextImg.removeAttribute('sizes');

  nextImg.src = nextImage.src;
  nextImg.alt = nextImage.alt || product.title || '';
}

      nextImg.style.transition = 'none';
      nextImg.style.opacity = '1';
      nextImg.style.visibility = 'visible';
      nextImg.style.transform = `translate3d(${direction > 0 ? width + delta : -width + delta}px,0,0)`;
    };

    const moveLayers = (delta) => {
      const list = images();
      if (list.length < 2) return;

      const width = getWidth();
      const limited = Math.max(-width, Math.min(width, delta));
      const direction = limited < 0 ? 1 : -1;

      gallery.classList.add('is-dragging-card');

      imgEl.style.transition = 'none';
      nextImg.style.transition = 'none';

      imgEl.style.transform = `translate3d(${limited}px,0,0)`;
      setNextLayer(direction, limited);
    };

    const commitImage = (direction) => {
      const list = images();
      if (list.length < 2) return;

      const nextIndex = getNextIndex(direction);
      const nextImage = list[nextIndex];

      if (!nextImage || !nextImage.src) {
        resetPositions();
        return;
      }

      product.cardImageIndex = nextIndex;

      imgEl.removeAttribute('srcset');
imgEl.removeAttribute('sizes');

imgEl.src = nextImage.src;
imgEl.alt = nextImage.alt || product.title || '';

resetPositions();
    };

    const snapBack = () => {
      const width = getWidth();
      const direction = dragDirection || ((currentX - startX) < 0 ? 1 : -1);

      imgEl.style.transition = 'transform 100ms ease-out';
      imgEl.style.transform = 'translate3d(0,0,0)';

      nextImg.style.transition = 'transform 100ms ease-out, opacity 100ms ease-out';
      nextImg.style.transform = `translate3d(${direction > 0 ? width : -width}px,0,0)`;
      nextImg.style.opacity = '0';

      window.setTimeout(resetPositions, 110);
    };

    const finish = () => {
      if (!isDown) return;

      isDown = false;

      const delta = currentX - startX;
      const threshold = 18;

      if (Math.abs(delta) > threshold) {
        markDragged(400);
        commitImage(delta < 0 ? 1 : -1);
      } else {
        snapBack();
      }

      if (pointerId !== null) {
        try { gallery.releasePointerCapture?.(pointerId); } catch (e) {}
      }

      pointerId = null;
    };

    const arrowHandler = (event, direction) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      markDragged(400);
      commitImage(direction);
    };

    prev?.addEventListener('pointerdown', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      markDragged(400);
    }, true);

    next?.addEventListener('pointerdown', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      markDragged(400);
    }, true);

    prev?.addEventListener('click', (event) => arrowHandler(event, -1), true);
    next?.addEventListener('click', (event) => arrowHandler(event, 1), true);

    gallery.addEventListener('pointerdown', (event) => {
      if (event.target?.closest?.('[data-gu-card-prev], [data-gu-card-next]')) return;

      const list = images();
      if (list.length < 2) return;

      isDown = true;
      pointerId = event.pointerId;
      startX = event.clientX;
      currentX = event.clientX;
      dragDirection = 0;

      imgEl.style.transition = 'none';
      nextImg.style.transition = 'none';

      try { gallery.setPointerCapture?.(event.pointerId); } catch (e) {}
    });

    gallery.addEventListener('pointermove', (event) => {
      if (!isDown) return;

      currentX = event.clientX;
      const delta = currentX - startX;

      if (Math.abs(delta) > 3) {
        markDragged(400);
        event.preventDefault();
        event.stopPropagation();
      }

      moveLayers(delta);
    });

    gallery.addEventListener('pointerup', finish);
    gallery.addEventListener('pointercancel', finish);
  });
}

  showLightbox() {
    if (!this.lightbox || !this.lightboxImg || !this.featureImg?.src) return;
    this.lightboxImg.src = this.featureImg.src;
    this.lightbox.hidden = false;
  }

  hideLightbox() {
    if (this.lightbox) this.lightbox.hidden = true;
  }

  openDetails() {
    const p = this.state.product;
    if (!p || !this.detailsModal || !this.detailsBody) return;
    const html = (p.descriptionHtml || '').trim();
    const text = (p.description || '').trim();
    if (!html && !text) return;
    this.detailsBody.innerHTML = html || `<p>${this.escapeHtml(text)}</p>`;
    this.detailsModal.hidden = false;
    this.updateModalState();
  }

  closeDetails() {
    if (this.detailsModal) this.detailsModal.hidden = true;
    this.updateModalState();
  }

  openSizeGuide() {
    this.state.unit = 'in';
    this.querySelectorAll('[data-gu-unit-toggle] [data-unit]').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.unit === 'in');
    });
    this.renderSizeTable();
    this.sizeModal.hidden = false;
    this.updateModalState();
  }

  closeSizeGuide() {
    if (this.sizeModal) this.sizeModal.hidden = true;
    this.updateModalState();
  }

  renderSizeTable() {
    const chart = this.state.product?.sizeChart;
    if (!this.sizeTable) return;
    if (!chart || !Array.isArray(chart.columns) || !Array.isArray(chart.sizes)) {
      this.sizeTable.innerHTML = '<div class="gu-size-note">NO SIZE CHART ENTERED YET.<br>ADD PRODUCT METAFIELD: custom.sizechart_data</div>';
      return;
    }
    const unit = this.state.unit || 'in';
    const columns = chart.columns || [];
    const rows = chart.sizes || [];
    this.sizeTable.innerHTML = `
      <table class="gu-size-table">
        <thead><tr><th>SIZE</th>${columns.map((col) => `<th>${this.escapeHtml(col)}</th>`).join('')}</tr></thead>
        <tbody>
          ${rows.map((row) => {
            const values = Array.isArray(row[unit]) ? row[unit] : [];
            return `<tr><td>${this.escapeHtml(row.label || '')}</td>${columns.map((_, i) => `<td>${this.escapeHtml(values[i] || '')}</td>`).join('')}</tr>`;
          }).join('')}
        </tbody>
      </table>
    `;
  }

  escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, (char) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[char]));
  }

  flyDotToCart(originEl) {
    const cartButton = this.querySelector('[data-gu-open-cart]');
    if (!originEl || !cartButton) return;
    const start = originEl.getBoundingClientRect();
    const end = cartButton.getBoundingClientRect();
    const dot = document.createElement('span');
    dot.className = 'gu-cart-fly-dot';
    dot.style.left = `${start.left + start.width / 2}px`;
    dot.style.top = `${start.top + start.height / 2}px`;
    document.body.appendChild(dot);
    requestAnimationFrame(() => {
      dot.style.transform = `translate(${end.left + end.width / 2 - (start.left + start.width / 2)}px, ${end.top + end.height / 2 - (start.top + start.height / 2)}px) scale(.35)`;
      dot.style.opacity = '0';
    });
    window.setTimeout(() => dot.remove(), 650);
  }

  async quickAdd(variantId, button) {
    if (!variantId) return;
    const original = button.textContent;
    button.disabled = true;
button.classList.add('is-adding');
button.textContent = 'ADDING';

button.style.setProperty('font-size', '10px', 'important');
button.style.setProperty('line-height', '1', 'important');
button.style.setProperty('letter-spacing', '0.04em', 'important');
button.style.setProperty('font-weight', '400', 'important');
button.style.setProperty('transform', 'none', 'important');

this.flyDotToCart(button);
    try {
      await this.addVariantToCart(variantId);
      this.openCart();
      this.renderCart();
    } catch (e) {
      console.error(e);
      button.textContent = '!';
      setTimeout(() => {
  button.textContent = original;
  button.disabled = false;
  button.classList.remove('is-adding');

  button.style.removeProperty('font-size');
  button.style.removeProperty('line-height');
  button.style.removeProperty('letter-spacing');
  button.style.removeProperty('font-weight');
  button.style.removeProperty('transform');
}, 900);
      return;
    }
    button.textContent = original;
button.disabled = false;
button.classList.remove('is-adding');

button.style.removeProperty('font-size');
button.style.removeProperty('line-height');
button.style.removeProperty('letter-spacing');
button.style.removeProperty('font-weight');
button.style.removeProperty('transform');
  }

  async addCurrentToCart() {
    const variant = this.state.variant;
    if (!variant?.id) return;
    this.addBtn.disabled = true;
    this.addBtn.textContent = 'ADDING';
    try {
      await this.addVariantToCart(variant.id);
      await this.renderCart();
      this.openCart();
    } catch (e) {
      console.error(e);
      this.addBtn.textContent = 'TRY AGAIN';
      this.addBtn.disabled = false;
      return;
    }
    this.addBtn.textContent = 'ADD';
    this.addBtn.disabled = false;
  }

  async addVariantToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error('Add failed');
    return res.json();
  }

  async renderCart() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  this.cartCountEls.forEach((el) => {
    const value = String(cart.item_count);
    el.setAttribute('data-real-count', value);

    if (el.querySelector('.gu-cart-count-track')) {
      el.innerHTML = `
        <span class="gu-cart-count-track" aria-hidden="true">
          <span class="gu-cart-count-digit">${value}</span>
          <span class="gu-cart-count-digit">${value}</span>
          <span class="gu-cart-count-digit">${value}</span>
        </span>
      `;
    } else {
      el.textContent = value;
    }
  });

  if (this.totalEl) {
    this.totalEl.textContent = this.money(cart.total_price);
  }

  const thresholdDollars = Number(this.dataset.freeShippingThreshold || 0);
  const thresholdCents = Math.round(thresholdDollars * 100);
  const cartTotal = Number(cart.total_price || 0);
  const hasFreeShipping = thresholdCents > 0 && cartTotal >= thresholdCents;

  if (this.shippingRow) {
  this.shippingRow.hidden = !hasFreeShipping;
}

if (this.totalRow) {
  this.totalRow.hidden = false;
}

  if (!cart.items.length) {
  this.drawer?.classList.add('is-empty');
  this.cartItems.classList.remove('is-multi');

  const emptyText = this.dataset.emptyCartText || 'YOUR CART IS EMPTY';
  this.cartItems.innerHTML = `<div class="gu-empty">${this.escapeHtml(emptyText)}</div>`;

  if (this.checkoutLink) {
    this.checkoutLink.textContent = this.dataset.backToShopText || 'BACK TO SHOP';
  }

  if (this.cartScrollCue) {
    this.cartScrollCue.classList.remove('is-visible');
    this.cartScrollCue.hidden = true;
    this.cartScrollCue.style.display = 'none';
  }

  return;
}

  this.drawer?.classList.remove('is-empty');

if (this.checkoutLink) {
  this.checkoutLink.textContent = this.dataset.checkoutText || 'CHECKOUT NOW';
}

this.cartItems.classList.toggle('is-multi', cart.items.length > 1);

  this.cartItems.innerHTML = cart.items.map((item) => `
    <div class="gu-cart-item" data-key="${this.escapeHtml(item.key)}" data-product-id="${this.escapeHtml(item.product_id || '')}" data-variant-id="${this.escapeHtml(item.variant_id || '')}">
      <button type="button" class="gu-cart-image" data-cart-open-product aria-label="Edit ${this.escapeHtml(item.product_title || '')}">
        <img src="${this.escapeHtml(item.image || '')}" alt="${this.escapeHtml(item.product_title || '')}">
      </button>

      <div class="gu-cart-meta">
        <button type="button" class="gu-cart-title" data-cart-open-product>${this.escapeHtml(item.product_title || '')}</button>
        <div>${item.variant_title && item.variant_title !== 'Default Title' ? this.escapeHtml(item.variant_title) : ''}</div>
        <div class="gu-cart-price">${this.money(item.final_line_price)}</div>

        <div class="gu-qty">
          <button type="button" data-dec>-</button>
          <span>${item.quantity}</span>
          <button type="button" data-inc>+</button>
        </div>

        <button type="button" class="gu-remove" data-remove>REMOVE</button>
      </div>
    </div>
  `).join('');

  this.cartItems.querySelectorAll('[data-key]').forEach((row) => {
    const key = row.dataset.key;
    const qty = Number(row.querySelector('.gu-qty span')?.textContent || 1);

    row.querySelector('[data-inc]')?.addEventListener('click', () => this.changeLine(key, qty + 1));
    row.querySelector('[data-dec]')?.addEventListener('click', () => this.changeLine(key, Math.max(0, qty - 1)));
    row.querySelector('[data-remove]')?.addEventListener('click', () => this.changeLine(key, 0));

    row.querySelectorAll('[data-cart-open-product]').forEach((button) => {
      button.addEventListener('click', () => {
        this.closeCart();
        this.openProduct(row.dataset.productId, row.dataset.variantId);
      });
    });
  });

  this.updateCartCue();
}

  updateCartCue() {
    if (!this.cartScrollWrap || !this.cartScrollCue) return;

    window.requestAnimationFrame(() => {
      const hasItems = !this.cartItems?.querySelector('.gu-empty');
      const canScroll = hasItems && this.cartScrollWrap.scrollHeight > this.cartScrollWrap.clientHeight + 8;
      const atTop = this.cartScrollWrap.scrollTop < 8;

      this.cartScrollCue.hidden = !canScroll;
      this.cartScrollCue.style.display = canScroll ? '' : 'none';
      this.cartScrollCue.classList.toggle('is-visible', canScroll && atTop);
    });

    this.cartScrollWrap.onscroll = () => this.updateCartCue();
  }

  async changeLine(key, quantity) {
    const row = this.cartItems?.querySelector(`[data-key="${CSS.escape(key)}"]`);
    if (row) {
      if (quantity === 0) row.remove();
      else row.style.opacity = '.45';
    }
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
    } finally {
      await this.renderCart();
    }
  }

  openCart() {
    this.drawer?.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    document.documentElement.classList.add('gu-cart-lock');
    document.body?.classList.add('gu-cart-lock');
    document.documentElement.style.overflow = 'hidden';
    if (document.body) document.body.style.overflow = 'hidden';
    if (this.cartScrollWrap) this.cartScrollWrap.scrollTop = 0;
    this.updateCartCue();
  }

  handleCheckoutClick(event) {
  event.preventDefault();

  if (this.drawer?.classList.contains('is-empty')) {
    this.closeCart();
    return false;
  }

  if (!this.termsCheckbox?.checked) {
      if (this.termsHint) {
        this.termsHint.hidden = false;
        window.setTimeout(() => { if (this.termsHint) this.termsHint.hidden = true; }, 2200);
      }
      return false;
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    const checkoutUrl = `${root.replace(/\/$/, '')}/checkout`;
    if (window.Shopify && window.Shopify.designMode) {
      window.open(checkoutUrl, '_blank', 'noopener');
    } else {
      window.location.href = checkoutUrl;
    }
    return false;
  }

  closeCart() {
    this.drawer?.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    document.documentElement.classList.remove('gu-cart-lock');
    document.body?.classList.remove('gu-cart-lock');
    document.documentElement.style.overflow = '';
    if (document.body) document.body.style.overflow = '';
  }
}

if (!customElements.get('greedy-one-page-shop')) {
  customElements.define('greedy-one-page-shop', GreedyOnePageShop);
}

/* =========================================================
   CART COUNT slot-roll on hover
   ========================================================= */
(() => {
  const initCartCountSlotRoll = () => {
    const cartButtons = document.querySelectorAll('.gu-stash-button');

    cartButtons.forEach((button) => {
      const count = button.querySelector('.gu-stash-count');
      if (!count || count.dataset.slotRollReady === 'true') return;

      count.dataset.slotRollReady = 'true';

      const getPlainCount = () => {
        const stored = count.getAttribute('data-real-count');
        if (stored !== null && stored !== '') return stored;
        const digit = count.querySelector('.gu-cart-count-digit');
        if (digit) return digit.textContent.trim() || '0';
        return count.textContent.trim() || '0';
      };

      const buildCount = (value) => {
        count.setAttribute('data-real-count', value);
        count.innerHTML = `
          <span class="gu-cart-count-track" aria-hidden="true">
            <span class="gu-cart-count-digit">${value}</span>
            <span class="gu-cart-count-digit">${value}</span>
            <span class="gu-cart-count-digit">${value}</span>
          </span>
        `;
      };

      buildCount(getPlainCount());

      button.addEventListener('mouseenter', () => {
        const value = getPlainCount();
        buildCount(value);
        count.classList.remove('is-rolling');
        void count.offsetWidth;
        count.classList.add('is-rolling');
        window.setTimeout(() => {
          count.classList.remove('is-rolling');
          buildCount(value);
        }, 340);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartCountSlotRoll);
  } else {
    initCartCountSlotRoll();
  }
})();

/* =========================================================
   Hide top controls on scroll-down
   ========================================================= */
(() => {
  const initHideControlsOnScroll = () => {
    const page = document.querySelector('.gu-page');
    const controls = document.querySelector('.gu-controls');
    if (!page || !controls || page.dataset.hideControlsReady === 'true') return;
    page.dataset.hideControlsReady = 'true';

    let lastY = window.scrollY || 0;
    let ticking = false;

    const update = () => {
      const currentY = window.scrollY || 0;
      const scrollingDown = currentY > lastY;
      const scrollingUp = currentY < lastY;

      if (currentY < 40) {
        page.classList.remove('gu-hide-controls');
      } else if (scrollingDown && currentY > 120) {
        page.classList.add('gu-hide-controls');
      } else if (scrollingUp) {
        page.classList.remove('gu-hide-controls');
      }

      lastY = currentY;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHideControlsOnScroll);
  } else {
    initHideControlsOnScroll();
  }
})();

/* =========================================================
   Pin magnifying glass to actual image edge
   ========================================================= */
(() => {
  const getZoomPosition = (page) => {
    const found = [...page.classList].find((name) => name.indexOf('gu-zoom-pos-') === 0);
    return found ? found.replace('gu-zoom-pos-', '') : 'top-right';
  };

  const setImportant = (el, prop, value) => el.style.setProperty(prop, value, 'important');

  const positionZoom = (page) => {
    const gallery = page.querySelector('.gu-feature-gallery');
    const img = page.querySelector('[data-gu-feature-img]');
    const zoom = page.querySelector('[data-gu-zoom]');
    if (!gallery || !img || !zoom || !img.getAttribute('src')) return;

    const g = gallery.getBoundingClientRect();
    const r = img.getBoundingClientRect();
    if (!g.width || !g.height || !r.width || !r.height) return;

    const pad = 10;
    const w = zoom.offsetWidth || 28;
    const h = zoom.offsetHeight || 28;
    const pos = getZoomPosition(page);

    let left = r.left - g.left + pad;
    let top = r.top - g.top + pad;

    if (pos.includes('right')) left = r.right - g.left - w - pad;
    if (pos.includes('center') && !pos.includes('top') && !pos.includes('bottom')) {
      left = r.left - g.left + (r.width - w) / 2;
      top = r.top - g.top + (r.height - h) / 2;
    }
    if (pos === 'top-center' || pos === 'bottom-center') left = r.left - g.left + (r.width - w) / 2;
    if (pos.includes('bottom')) top = r.bottom - g.top - h - pad;

    setImportant(zoom, 'left', `${Math.max(0, left)}px`);
    setImportant(zoom, 'right', 'auto');
    setImportant(zoom, 'top', `${Math.max(0, top)}px`);
    setImportant(zoom, 'bottom', 'auto');
    setImportant(zoom, 'transform', 'none');
  };

  const initZoomPinning = () => {
    document.querySelectorAll('greedy-one-page-shop').forEach((page) => {
      if (page.dataset.zoomPinned === 'true') return;
      page.dataset.zoomPinned = 'true';
      const img = page.querySelector('[data-gu-feature-img]');
      if (img) {
        img.addEventListener('load', () => requestAnimationFrame(() => positionZoom(page)));
        new MutationObserver(() => requestAnimationFrame(() => positionZoom(page))).observe(img, { attributes: true, attributeFilter: ['src'] });
      }
      new MutationObserver(() => requestAnimationFrame(() => positionZoom(page))).observe(page, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', () => requestAnimationFrame(() => positionZoom(page)), { passive: true });
      requestAnimationFrame(() => positionZoom(page));
      setTimeout(() => positionZoom(page), 250);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initZoomPinning);
  else initZoomPinning();
})();